/*
  Плашка дашборда «реестр банкротств нашёл должников» - вариант Б, 27.10.2026.

  Зачем на первом экране. Сильная находка сама останавливает подачу по счетам человека
  (вариант А владельца), и если об этом не сказать там, куда человек приходит утром, счета
  будут стоять молча: потерянный долг, о причине которого никто не знает. Плашка красная,
  как «горит срок давности»: оба случая - деньги, которые уходят, пока на них не смотрят.

  Сама плашка ничего не решает: кнопка ведёт к списку находок, а решение принимается на
  карточке счёта. Нового пункта меню нет намеренно (решение владельца).

  Видна только тем, кто подаёт заявления (право `build_documents`): остановка подачи -
  их решение, и сводку сервер другим не отдаёт.
*/

import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { api } from '../api/client.js'
import { accountsDative, plural } from '../api/format.js'

const findings = (count) => plural(count, 'находка', 'находки', 'находок')

export default function RegistryFindingsBanner({ profile }) {
  const allowed = Boolean(profile?.permissions?.includes('build_documents'))
  const [summary, setSummary] = useState(null)

  useEffect(() => {
    if (!allowed) return
    // Плашка - дополнение к экрану: не загрузилась, и дашборд остаётся целым.
    api
      .registryFindingsSummary()
      .then(setSummary)
      .catch(() => setSummary(null))
  }, [allowed])

  if (!allowed || !summary || summary.pending === 0) return null

  return (
    <div className="notice notice--error notice--wide">
      <div className="notice__what">
        Реестр банкротств нашёл должников - к разбору: {findings(summary.pending)}
      </div>
      <div className="notice__do">
        {summary.stopped_accounts > 0
          ? `По ${accountsDative(summary.stopped_accounts)} подача остановлена до вашего решения. `
          : 'Подача не остановлена: совпадения спорные, их нужно сверить. '}
        <Link to="/registry-findings">Разобрать находки</Link>
      </div>
    </div>
  )
}
